import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Container } from '../styles/styled';

const HeaderWrapper = styled.header`
  text-align: center;
  padding: 120px 0 40px 0;
  background: #fff;

  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }

  > div {
    max-width: 900px;
    margin: 0 auto;
    padding: 0 20px;

    h1 {
      font-size: 42px;
      margin-bottom: 25px;
      color: #002dff;
      font-weight: 700;
      line-height: 1.2;

      @media (max-width: 1200px) {
        font-size: 48px;
      }

      @media (max-width: 992px) {
        font-size: 42px;
      }

      @media (max-width: 768px) {
        font-size: 34px;
      }

      @media (max-width: 480px) {
        font-size: 28px;
      }
    }

    p {
      font-size: 20px;
      margin-bottom: 40px;
      color: #555;
      line-height: 1.6;

      @media (max-width: 992px) {
        font-size: 18px;
      }

      @media (max-width: 768px) {
        font-size: 16px;
        margin-bottom: 30px;
      }

      @media (max-width: 480px) {
        font-size: 15px;
      }
    }

    .btn {
      display: inline-block;
      padding: 15px 35px;
      color: #002dff;
      font-weight: 700;
      background-color: #78ffd6;
      border-radius: 12px;
      text-decoration: none;
      font-size: 18px;
      transition: all 0.3s ease;

      &:hover {
        background-color: #29f0b4;
        transform: translateY(-2px);
      }

      @media (max-width: 768px) {
        padding: 12px 28px;
        font-size: 16px;
      }

      @media (max-width: 480px) {
        padding: 10px 24px;
        font-size: 15px;
      }
    }

    .short-desc {
      font-size: 16px;
      color: #777;
      margin-top: 25px;
      font-style: italic;

      @media (max-width: 768px) {
        font-size: 15px;
        margin-top: 20px;
      }

      @media (max-width: 480px) {
        font-size: 14px;
      }
    }
  }

  /* адаптация отступов */
  @media (max-width: 992px) {
    padding: 100px 0;
  }

  @media (max-width: 768px) {
    padding: 80px 0;
  }

  @media (max-width: 480px) {
    padding: 60px 0;
  }
`;

const Header = () => {
  const { t } = useTranslation('common');
  const headerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (headerRef.current) observer.observe(headerRef.current);
    return () => {
      if (headerRef.current) observer.unobserve(headerRef.current);
    };
  }, []);

  // Обработка заголовка с разрывом строки
  const titleLines = t('header.title').split('\n');

  return (
    <HeaderWrapper ref={headerRef}>
      <Container>
        <h1>
          {titleLines.map((line, index) => (
            <React.Fragment key={index}>
              {line}
              {index < titleLines.length - 1 && <br />}
            </React.Fragment>
          ))}
        </h1>
        <p>{t('header.description')}</p>
        <a className="btn" href="#contact">
          {t('header.getStarted')}
        </a>
        <p className="short-desc">
          {t('header.shortDesc')}
        </p>
      </Container>
    </HeaderWrapper>
  );
};

export default Header;